import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  CircularProgress,
  Paper,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Assignment as AssignmentIcon,
  List as ListIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store.js';
import {
  obtenerTareasGenerales,
  obtenerTareasGeneralesAsignadas,
} from '../../../actions/TareasAction.js';
import TTareas from '../TTareas';
export default function PanelDeTareas(props) {
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [radioValor, setRadioValor] = useState('Todas');
  const [term, setTerm] = useState('');
  const [Datat, setDatat] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);
  const radioValorHandleChange = (event) => {
    setRadioValor(event.target.value);
  };
  useEffect(() => {
    switch (radioValor) {
      case 'Todas':
        setDatosCargados(false);
        obtenerTareasGenerales().then((response) => {
          if (response.status === 200) {
            setDatat(response.data);
            setDatosCargados(true);
          } else {
            console.log('NO CARGO TAREAS GENERALES');
          }
        });
        break;
      case 'AsignadoPor':
        setDatosCargados(false);
        obtenerTareasGeneralesAsignadas(sesionUsuario.usuario.id).then(
          (response) => {
            if (response.status === 200) {
              setDatat(response.data);
              setDatosCargados(true);
            } else {
              console.log('NO CARGO TAREAS ASIGNADAS POR');
            }
          }
        );
        break;
      default:
        console.log('ERROR EN SWITCH CASE');
    }
  }, [sesionUsuario, radioValor]);
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -20,
            top: -20,
            opacity: 0.2,
          }}
        >
          <AssignmentIcon sx={{ fontSize: 120, transform: 'rotate(-15deg)' }} />
        </Box>
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="white"
            sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}
          >
            <AssignmentIcon sx={{ fontSize: 40 }} />
            Panel General de Tareas
          </Typography>
          {datosCargados && (
            <Chip
              label={`${Datat.length} tareas`}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                fontWeight: 600,
              }}
            />
          )}
        </Box>
      </Paper>

      {/* Search Bar */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar tareas..."
          name="term"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Paper>

      {/* Filters */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <RadioGroup
          row
          value={radioValor}
          onChange={radioValorHandleChange}
          sx={{ gap: 2, flexWrap: 'wrap' }}
        >
          <FormControlLabel
            value="Todas"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ListIcon sx={{ fontSize: 20 }} />
                <Typography>Todas las Tareas</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="AsignadoPor"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ fontSize: 20 }} />
                <Typography>
                  Tareas Asignadas por {sesionUsuario.usuario.nombrecompleto}
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
      </Paper>

      {/* Content */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {datosCargados ? (
          <TTareas
            rows={Datat}
            termc={term}
            history={props.history}
            id={'Visitante'}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="h6" color="text.secondary">
              Cargando tareas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
